import { render, staticRenderFns } from "./Thankyou.vue?vue&type=template&id=6dd9b880&scoped=true"
import script from "./Thankyou.vue?vue&type=script&lang=js"
export * from "./Thankyou.vue?vue&type=script&lang=js"
import style0 from "./Thankyou.vue?vue&type=style&index=0&id=6dd9b880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd9b880",
  null
  
)

export default component.exports